import { useQuery } from '@tanstack/react-query';
import getActivity from '@/api/content/getActivity.endpoint';
import { QUERY_KEYS } from '@/v2/constants/QueryKeys';

const anHour = 60 * 60 * 1000;

export default function useGetActivityQuery({ activityId }) {
  return useQuery({
    queryKey: [QUERY_KEYS.ACTIVITY, activityId],
    queryFn: () => getActivity(activityId),
    enabled: !!activityId,
    refetchOnWindowFocus: false,
    staleTime: anHour,
    meta: {
      notification: {
        error: "We couldn't load the activity. Please try again.",
      },
    },
  });
}
